import { render, staticRenderFns } from "./Colores.vue?vue&type=template&id=07f1862c"
import script from "./Colores.vue?vue&type=script&lang=js"
export * from "./Colores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports